import { useQueryClient as useRQueryClient } from "react-query";
import { UseQueryClientReturnType } from "./types";

export const useQueryClient = (): UseQueryClientReturnType => {
  return useRQueryClient();
};
